export default __webpack_public_path__ + "media/shipment/siuntu_pilotai-7e17593c.svg";